import React from 'react';

import { useConfirmacao } from 'Component/Alerta';
import Icone from 'Component/Icone';

interface Props {
    icone?: string;
    children?: string | React.ReactElement | React.ReactElement[];
    className?: string;
    iconeClassName?: string;
    confirmacao?: string;
    onClick?: () => void;
    tema?: 'success'
        | 'warning'
        | 'danger'
        | 'info'
        | 'light'
        | 'dark'
        | 'darkless'
        | 'primary'
        | 'secondary'
        | 'transparent'
        | 'outline-success'
        | 'outline-warning'
        | 'outline-danger'
        | 'outline-info'
        | 'outline-light'
        | 'outline-dark'
        | 'outline-darkless'
        | 'outline-primary'
        | 'outline-secondary';
    type?: 'button' | 'submit' | 'reset';
    circulo?: boolean;
    sm?: boolean;
    lg?: boolean;
    ms?: boolean;
    me?: boolean;
    processando?: boolean;
}

const Botao = (props: Props): React.ReactElement =>
{
    const modal = useConfirmacao();
    const {
        icone,
        children,
        className,
        iconeClassName,
        confirmacao,
        onClick,
        tema = 'primary',
        type = 'button',
        circulo,
        sm,
        lg,
        ms,
        me,
        processando = false,
    } = props;

    return (
        <button
            type={ type }
            className={[
                `btn btn-${tema}`,
                'text-nowrap',
                sm && 'btn-sm',
                lg && 'btn-lg',
                ms && 'ms-2',
                me && 'me-2',
                circulo && 'rounded-circle',
                className,
            ].paraClassName()}
            { ...onClick
                ? { onClick: () => (
                    typeof confirmacao === 'string'
                        ? modal({ conteudo: confirmacao, aoConfirmar: onClick })
                        : onClick()
                    )
                }
                : {}
            }
            { ...processando ? { disabled: true } : {} }
        >
            { icone && (
                <Icone
                    nome={ icone }
                    { ...children ? { className: 'me-2 ' + iconeClassName } : {}}
                />
            ) }
            { !processando ? children : 'Aguarde...' }
        </button>
    )
}

export default Botao;
